import React, { useState, useEffect } from 'react';
import {fetchSingleCryptoAsset} from '../../api/ApiUtils';


function SingleCoin (props) {
    console.log(props);
    const asset_symbol = props.asset_symbol;
    const attributes = "id,name,logo_url,description,website_url,block_explorer_url,original_symbol,whitepaper_url"
    const [cryptoAsset, setCryptoAsset] = useState([]);
    useEffect(() => {
        async function fetchMyAPI() {
          let response = await fetchSingleCryptoAsset(asset_symbol,attributes)
          console.log(response.data[0]);
          setCryptoAsset(response.data[0])
          
        }
        fetchMyAPI()
    },[])
    return (
        <div>

            <div className="row mt-5">
                <img
                  style={{ height: "50px", width: "50px" }} 
                  src={cryptoAsset.logo_url} />
                <div className="col h3">{cryptoAsset.name} | {cryptoAsset.original_symbol}</div> 
                <div className="col">Current Price</div> 
            </div>

            <hr/>

            <div className="row">
                <div className="col-md-4 mt-2"><a href={cryptoAsset.website_url} target="_blank" className="btn btn-primary">Website</a></div>
                <div className="col-md-4 my-1"> <a href={cryptoAsset.whitepaper_url} target="_blank" className="btn btn-primary">White Paper</a></div>
                <div className="col-md-4 my-1"><a href={cryptoAsset.block_explorer_url} target="_blank" className="btn btn-primary">Block Explorer</a></div>
            </div>

            <hr/>
            <div className="row mt-2">
                <div className="col-6"> Chart</div>
                <div className="col-6">Latest News</div>
            </div>

            <hr/>
            <div className="row my-2">
                <div className="h3"> Description: </div>
                {cryptoAsset.description}
            </div>
        </div>
        
    );
  }


export default SingleCoin